<template>
  <div class="container">
    <!-- Modales -->
    <b-modal no-close-on-backdrop centered ref="entrega-documento-modal" title="" hide-footer id="modalC" size="xl">
      <div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(postDocumento)">
            <ModalEntregaDocumento
              accepted-file-types="application/pdf"
              :currentDocumento="currentDocumento"
              :cotejo="cotejo"
              @submit.prevent
            />
          </form>
        </ValidationObserver>
      </div>
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-img" title="" hide-footer id="modaldi" size="xl">
      <ModalPreviewImg :currentDocumento="currentDocumento" />
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-pdf" title="" hide-footer id="modaldf" size="xl">
      <ModalPreviewPDF :currentDocumento="currentDocumento" />
    </b-modal>

    <!-- Template -->
    <h4 class="cardD">Revisión de documentos originales</h4>

    <b-table ref="table" hover :fields="fieldsDocumentos" :items="documentosToShow">
      <template #cell(descripcion)="{ item }">
        <div v-if="item.tipo === 'Otro'">
          <div v-b-tooltip.hover :title="item.descripcion">
            {{ item.tipo + " - " + item.descripcion }}
          </div>
        </div>
        <div v-else-if="item.tipo === 'Anexo'">
          {{ item.nombre }}
        </div>
        <div v-else>
          {{ item.tipo }}
        </div>
      </template>
      <template #cell(pdf_staff)="{ item }">
        <div v-if="item.validacion?.documentos_staff_id">
          <b-button
            variant="primary"
            size="sm"
            v-b-tooltip.hover
            title="Vista previa"
            @click="previewStaffDocumento(item)"
            class="editBtn"
          >
            <b-icon-eye />
          </b-button>
        </div>
        <div v-else>Sin subir</div>
      </template>
      <template #cell(numero_cotejos)="{ item }">
        <div v-if="item.validacion">
          <b-form-input
            type="text"
            v-model="item.validacion.numero_cotejos"
            @input="debouncedUpdateValidacion(item)"
          ></b-form-input>
        </div>
      </template>
      <template #cell(acta_cotejo)="{ item }">
        <div v-if="item.validacion">
          <b-form-input type="text" v-model="item.validacion.acta_cotejo" @input="debouncedUpdateValidacion(item)"></b-form-input>
        </div>
      </template>
      <template #cell(fecha_cotejo)="{ item }">
        <div v-if="item.validacion">
          <b-form-input
            type="date"
            v-model="item.validacion.fecha_cotejo"
            @input="debouncedUpdateValidacion(item)"
          ></b-form-input>
        </div>
      </template>
      <template #cell(listo_entrega)="{ item }">
        <div v-if="item.validacion">
          <b-form-checkbox v-model="item.validacion.listo_entrega" @change="updateDocumentoFlag(item)"></b-form-checkbox>
        </div>
      </template>
    </b-table>

    <div class="d-flex mt-4">
      <div class="ml-auto">
        <!-- <b-button type="submit" class="btn-fill green-btn bottom2" :disabled="isButtonDisabled">
          Enviar correo al cliente
        </b-button> -->
        <b-button class="btn-fill orange-btn bottom2" :disabled="isButtonDisabled" @click="$emit('allChecksPassed')">
          Validar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPreviewImg from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewImg.vue";
import ModalPreviewPDF from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewPDF.vue";
import ModalEntregaDocumento from "@/views/clients/procesos/cotejo/infoBase/modales/ModalEntregaDocumento.vue";

import { DocumentosApi, FuncionesApi, ValidacionesDocumentosApi } from "@/api";
import loadingMixin from "@/mixins/loadingMixin";
import { formatCurrency } from "@/utils/number-utils";
import debounce from "lodash.debounce";

export default {
  name: "CotejoListo",

  components: {
    ModalEntregaDocumento,
    ModalPreviewImg,
    ModalPreviewPDF,
  },

  mixins: [loadingMixin],

  props: {
    cotejo: { type: Object },
  },

  computed: {
    isButtonDisabled() {
      return false;
    },
  },

  created() {
    this.toggleOnLoading();
    this.selectDocumentosToShow()
      .then(() => this.areDocumentosCompletos())
      .then(() => this.checkDocsUploaded())
      .then(() => this.fetchOrCreateValidaciones())
      .catch((error) => {
        this.showErrorToast("No se pudieron cargar los documentos. Intente más tarde.");
        console.log(error);
      })
      .finally(this.toggleOffLoading);

    this.debouncedUpdateValidacion = debounce(this.updateDocumentoFlag, 1500);
  },

  data() {
    return {
      fieldsDocumentos: [
        { key: "descripcion", label: "Descripción", class: "text-center" },
        { key: "pdf_staff", label: "PDF Staff", class: "text-center" },
        { key: "numero_cotejos", label: "# Cotejos", class: "text-center" },
        { key: "acta_cotejo", label: "Acta", class: "text-center" },
        { key: "fecha_cotejo", label: "Fecha", class: "text-center" },
        { key: "listo_entrega", label: "Listo para entrega", class: "text-center" },
      ],

      documentosToShow: [],
      documentosCompletos: false,

      currentDocumento: {},
      isUploadingStaffDoc: false,
    };
  },

  methods: {
    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    async selectDocumentosToShow() {
      const cat_documentos_id_to_include = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 29, 73];

      this.documentosToShow = this.cotejo.documentos.filter(
        (doc) => cat_documentos_id_to_include.includes(Number(doc.cat_documentos_id)) && doc.numero_documento !== 2,
      );
    },

    async checkDocsUploaded() {
      this.documentosToShow.forEach((doc) => {
        doc.tieneDocumento = doc.documento ? "✔" : "X";
      });
    },

    openUploadStaffModal(documento) {
      this.isUploadingStaffDoc = true;
      this.currentDocumento = documento;
      this.$refs["entrega-documento-modal"].show();
    },

    openEditDocumentoModal(documento) {
      this.isUploadingStaffDoc = false;
      this.$refs["entrega-documento-modal"].show();
      this.currentDocumento = documento;
    },

    hideEditDocumentoModal() {
      this.$refs["entrega-documento-modal"].hide();
      this.isUploadingStaffDoc = false;
    },

    postDocumento() {
      this.hideEditDocumentoModal();
      if (this.isUploadingStaffDoc) {
        this.sendStaffDocumentoToAzureStorage();
      } else {
        this.sendCurrentDocumentoToAzureStorage();
      }
    },

    async sendStaffDocumentoToAzureStorage() {
      try {
        this.toggleOnLoading();

        this.currentDocumento.nombre = this.currentDocumento.file.name;

        const formData = new FormData();
        formData.append("file", this.currentDocumento.file);
        // Using "documentosCotejos" path just like normal documents, or another path if specified
        const path = await FuncionesApi.file(this.cotejo.id, "documentosCotejos", formData, {});

        this.currentDocumento.documento = path;
        // Since we need to create a new Documento via DocumentoApi and then update ValidacionDocumento
        await this.createStaffDocumentoBD();
      } catch (error) {
        this.showErrorToast("Error al mandar el archivo. Intente más tarde.");
        console.log(error);
      } finally {
        this.toggleOffLoading();
        this.isUploadingStaffDoc = false;
      }
    },

    async createStaffDocumentoBD() {
      try {
        const payload = {
          documento: this.currentDocumento.documento,
          cat_documentos_id: this.currentDocumento.cat_documentos_id,
          auto_referencia: this.currentDocumento.auto_referencia,
          descripcion: this.currentDocumento.descripcion,
          paginas: parseInt(this.currentDocumento.paginas) || 0,
          copias_certificadas: parseInt(this.currentDocumento.copias_certificadas) || 0,
          nombre: this.currentDocumento.nombre,
          activo: 1,
          cotejos_id: this.cotejo.id,
        };
        const resCreate = await DocumentosApi.create(payload);
        const newStaffDoc = resCreate.data ? resCreate.data : resCreate;

        // Update validacionesDocumentos
        if (this.currentDocumento.validacion) {
          this.currentDocumento.validacion.documentos_staff_id = newStaffDoc.id;
          this.$set(this.currentDocumento.validacion, "staffDocFetched", newStaffDoc);
          await this.updateDocumentoFlag(this.currentDocumento);
        }

        // We update the table specifically to reflect the staff doc UI change
        const cotejoDocumentosIndex = this.getcotejoDocumentosIndex(this.currentDocumento);
        this.documentosToShow.splice(cotejoDocumentosIndex, 1, this.currentDocumento);
      } catch (error) {
        this.showErrorToast("Error al crear el documento staff. Intente más tarde.");
        console.log(error);
      }
    },

    async sendCurrentDocumentoToAzureStorage() {
      try {
        this.toggleOnLoading();

        this.currentDocumento.nombre = this.currentDocumento.file.name;

        const formData = new FormData();
        formData.append("file", this.currentDocumento.file);
        const path = await FuncionesApi.file(this.cotejo.id, "documentosCotejos", formData, {});

        this.currentDocumento.documento = path;
        this.currentDocumento.tieneDocumento = "✔";
        this.updateDocumentoBD();
      } catch (error) {
        this.showErrorToast("Error al mandar el archivo. Intente más tarde.");
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    async updateDocumentoBD() {
      try {
        this.toggleOnLoading();

        await DocumentosApi.edit(this.currentDocumento.id, {
          documento: this.currentDocumento.documento,
          cat_documentos_id: this.currentDocumento.cat_documentos_id,
          auto_referencia: this.currentDocumento.auto_referencia,
          descripcion: this.currentDocumento.descripcion,
          paginas: parseInt(this.currentDocumento.paginas),
          copias_certificadas: parseInt(this.currentDocumento.copias_certificadas),
          nombre: this.currentDocumento.nombre,
          activo: 1,
        });
        this.updatecotejoDocumentoFromCurrentDocumento();
      } catch (error) {
        this.showErrorToast("Error al actualizar el documento. Intente más tarde.");
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    updatecotejoDocumentoFromCurrentDocumento() {
      const cotejoDocumentosIndex = this.getcotejoDocumentosIndex(this.currentDocumento);
      this.documentosToShow[cotejoDocumentosIndex] = this.currentDocumento;
      this.documentosToShow[cotejoDocumentosIndex].tieneDocumento = "✔";
      this.areDocumentosCompletos();
    },

    getcotejoDocumentosIndex(documento) {
      return this.documentosToShow.findIndex((d) => d.id === Number(documento.id));
    },

    previewDocumento(item) {
      this.currentDocumento = item;

      const refName = this.isCurrentDocumentAnImage() ? "documento-modal-preview-img" : "documento-modal-preview-pdf";

      this.$refs[refName].show();
    },

    isCurrentDocumentAnImage() {
      if (!this.currentDocumento || !this.currentDocumento.nombre) return false;
      const extension = this.currentDocumento.nombre.split(".").pop().toLowerCase();
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "avif"];

      return imageExtensions.includes(extension);
    },

    async previewStaffDocumento(item) {
      if (!item.validacion || !item.validacion.documentos_staff_id) return;

      try {
        this.toggleOnLoading();
        let staffDoc = item.validacion.staffDocFetched;

        if (!staffDoc) {
          const res = await DocumentosApi.detail(item.validacion.documentos_staff_id);
          staffDoc = res.data ? res.data : res;
          this.$set(item.validacion, "staffDocFetched", staffDoc);
        }

        this.currentDocumento = staffDoc;
        const refName = this.isCurrentDocumentAnImage() ? "documento-modal-preview-img" : "documento-modal-preview-pdf";
        this.$refs[refName].show();
      } catch (error) {
        this.showErrorToast("Error al cargar la vista previa del documento staff.");
        console.error(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    areDocumentosCompletos() {
      let completos = true;

      if (this.documentosToShow.length == 0) {
        return;
      }
      this.documentosToShow.forEach((documento) => {
        if (documento.documento == "") {
          completos = false;
        }
      });

      this.documentosCompletos = completos;
    },

    formatCurrency,

    async fetchOrCreateValidaciones() {
      const promesas = this.documentosToShow.map(async (doc) => {
        try {
          const res = await ValidacionesDocumentosApi.getValidacionesDocumentosCliente(doc.id);
          const validacion = res.data ? res.data : res;
          this.$set(doc, "validacion", validacion);
        } catch (error) {
          if (error.status === 404) {
            const nuevaValidacion = { documentos_cliente_id: doc.id };
            const resCreate = await ValidacionesDocumentosApi.create(nuevaValidacion);
            const validacionCreate = resCreate.data ? resCreate.data : resCreate;
            this.$set(doc, "validacion", validacionCreate);
          } else {
            console.error("Error obteniendo validación para documento:", doc.id, error);
            this.$set(doc, "validacion", {}); // fallback to avoid errors
          }
        }
      });
      await Promise.all(promesas);
    },

    async updateDocumentoFlag(item) {
      if (!item.validacion || !item.validacion.id) {
        return;
      }
      try {
        this.toggleOnLoading();
        await ValidacionesDocumentosApi.edit(item.validacion.id, item.validacion);
        this.$toast.success("Validación actualizada correctamente", {
          timeout: 3000,
          position: "top-right",
          icon: true,
        });
      } catch (error) {
        this.showErrorToast("Error al actualizar la validación. Intente más tarde.");
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    async descargarDocumento(documento) {
      try {
        this.toggleOnLoading();

        const response = await FuncionesApi.descargarDocumento(documento.id);
        const filename = documento.documento.split("/").pop();

        saveAs(response, filename);
      } catch (error) {
        console.error("Error downloading file:", error);
        this.showErrorToast("Error al descargar el archivo.");
      } finally {
        this.toggleOffLoading();
      }
    },
  },
};
</script>
